const EXAM_TYPES = {
  // AR: { key: 'AR', name: 'Autorefraction' },
  // ASMT: { key: 'ASMT', name: 'Content Assessment Results' },
  // AU: { key: 'AU', name: 'Audio' },
  // BDUS: { key: 'BDUS', name: 'Bone Densitometry (ultrasound)' },
  // BI: { key: 'BI', name: 'Biomagnetic imaging' },
  // BMD: { key: 'BMD', name: 'Bone Densitometry (X-Ray)' },
  CR: { key: 'CR', name: 'Computed Radiography' },
  CT: { key: 'CT', name: 'Computed Tomography' },
  // DG: { key: 'DG', name: 'Diaphanography' },
  // DOC: { key: 'DOC', name: 'Document' },
  DX: { key: 'DX', name: 'Digital Radiography' },
  // ECG: { key: 'ECG', name: 'Electrocardiography' },
  // EPS: { key: 'EPS', name: 'Cardiac Electrophysiology' },
  // ES: { key: 'ES', name: 'Endoscopy' },
  // FID: { key: 'FID', name: 'Fiducials' },
  // GM: { key: 'GM', name: 'General Microscopy' },
  // HC: { key: 'HC', name: 'Hard Copy' },
  // HD: { key: 'HD', name: 'Hemodynamic Waveform' },
  // IO: { key: 'IO', name: 'Intra-Oral Radiography' },
  // IOL: { key: 'IOL', name: 'Intraocular Lens Data' },
  // IVOCT: { key: 'IVOCT', name: 'Intravascular Optical Coherence Tomography' },
  // IVUS: { key: 'IVUS', name: 'Intravascular Ultrasound' },
  // KER: { key: 'KER', name: 'Keratometry' },
  // KO: { key: 'KO', name: 'Key Object Selection' },
  // LEN: { key: 'LEN', name: 'Lensometry' },
  // LS: { key: 'LS', name: 'Laser surface scan' },
  // MG: { key: 'MG', name: 'Mammography' },
  // MR: { key: 'MR', name: 'Magnetic Resonance' },
  // NM: { key: 'NM', name: 'Nuclear Medicine' },
  // OAM: { key: 'OAM', name: 'Ophthalmic Axial Measurements' },
  // OCT: { key: 'OCT', name: 'Optical Coherence Tomography (non-Ophthalmic)' },
  // OP: { key: 'OP', name: 'Ophthalmic Photography' },
  // OPM: { key: 'OPM', name: 'Ophthalmic Mapping' },
  // OPT: { key: 'OPT', name: 'Ophthalmic Tomography' },
  // OPV: { key: 'OPV', name: 'Ophthalmic Visual Field' },
  // OSS: { key: 'OSS', name: 'Optical Surface Scan' },
  // OT: { key: 'OT', name: 'Other' },
  // PLAN: { key: 'PLAN', name: 'Plan' },
  // PR: { key: 'PR', name: 'Presentation State' },
  // PT: { key: 'PT', name: 'Positron emission tomography (PET)' },
  // PX: { key: 'PX', name: 'Panoramic X-Ray' },
  // REG: { key: 'REG', name: 'Registration' },
  // RESP: { key: 'RESP', name: 'Respiratory Waveform' },
  // RF: { key: 'RF', name: 'Radio Fluoroscopy' },
  // RG: { key: 'RG', name: 'Radiographic imaging (conventional film/screen)' },
  // RTDOSE: { key: 'RTDOSE', name: 'Radiotherapy Dose' },
  // RTIMAGE: { key: 'RTIMAGE', name: 'Radiotherapy Image' },
  // RTPLAN: { key: 'RTPLAN', name: 'Radiotherapy Plan' },
  // RTRECORD: { key: 'RTRECORD', name: 'RT Treatment Record' },
  // RTSTRUCT: { key: 'RTSTRUCT', name: 'Radiotherapy Structure Set' },
  // RWV: { key: 'RWV', name: 'Real World Value Map' },
  // SEG: { key: 'SEG', name: 'Segmentation' },
  // SM: { key: 'SM', name: 'Slide Microscopy' },
  // SMR: { key: 'SMR', name: 'Stereometric Relationship' },
  // SR: { key: 'SR', name: 'SR Document' },
  // SRF: { key: 'SRF', name: 'Subjective Refraction' },
  // STAIN: { key: 'STAIN', name: 'Automated Slide Stainer' },
  // TG: { key: 'TG', name: 'Thermography' },
  // US: { key: 'US', name: 'Ultrasound' },
  // VA: { key: 'VA', name: 'Visual Acuity' },
  // XA: { key: 'XA', name: 'X-Ray Angiography' },
  // XC: { key: 'XC', name: 'External-camera Photography' },
};

export default EXAM_TYPES;
